import React from 'react';

import { Box } from '@mui/material';

import {
  PermissiblePurposeStatus,
  useGetDashboardCvAdminVerifiersDataQuery,
  useGetDashboardPlatformAdminTopVerifiersDataQuery,
  usePermissiblePurposeReferencesListDashboardVerifiersTabQuery,
} from 'src/api';
import { useDashboardPrintView } from 'src/hooks/dashboard';

import { DashboardVerifiersBlock } from './components';
import { DashboardPermissiblePurposeBlock } from './components/DashboardPermissiblePurposeBlock';
import { DashboardTopVerifiersDataBlock } from './components/DashboardTopVerifiersDataBlock';

export const DashboardVerifiersCVAdmin: React.FC = () => {
  const { isPrintView } = useDashboardPrintView();

  const { data: verifiersData, loading: loadingVerifiersData } =
    useGetDashboardCvAdminVerifiersDataQuery();

  const { data: topVerifiersData, loading: topVerifiersLoading } =
    useGetDashboardPlatformAdminTopVerifiersDataQuery();

  const { data: permissiblePurposeReferencesData, loading: loadingPermissiblePurposeReferences } =
    usePermissiblePurposeReferencesListDashboardVerifiersTabQuery({
      variables: {
        permissiblePurposeFilter: {
          status: {
            equals: PermissiblePurposeStatus.Approved,
          },
        },
      },
    });

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={2}
      margin={isPrintView ? '0 32px 32px' : 'none'}
    >
      <DashboardVerifiersBlock
        dashboardVerifiersData={verifiersData?.getDashboardCVAdminVerifiersData}
        loading={loadingVerifiersData}
      />
      <DashboardPermissiblePurposeBlock
        permissiblePurposeReferenceData={
          permissiblePurposeReferencesData?.permissiblePurposeReferenceList || []
        }
        loading={loadingPermissiblePurposeReferences}
      />
      <DashboardTopVerifiersDataBlock
        topVerifiersData={topVerifiersData?.getDashboardPlatformAdminTopVerifiersData || []}
        loading={topVerifiersLoading}
      />
    </Box>
  );
};
